import {Button, Card, Checkbox, Divider} from "antd";
import React, {useEffect, useState} from "react";
import MemberTypeComponent from "@/components/member-type/MemberTypeComponent";
import RenderIf from "@/components/render-if";
import PermList from "@/lib/helper/PermList";
import {Can, hasPermission} from "@/components/can/Can";
import {useApiSearchAdminRoles, useApiUpdateAdminMemberRole} from "@/api/roles";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

export default function PermissionTab({student}) {
    const [superAdmin, setSuperAdmin] = useState(false)
    const [currentMyRole, setCurrentMyRole] = useState([])
    const [roleList, setRoleList] = useState([])

    const {mutate: addUserRole, isPending: isPendingAddUserRole} = useApiUpdateAdminMemberRole()
    const {data: roles, isPending: isPendingGetRoles} = useApiSearchAdminRoles()

    const handleChange = (id) => {
        if (currentMyRole.includes(id)) {
            const myRoles = currentMyRole.filter((item) => item !== id)
            setCurrentMyRole(myRoles)
        } else {
            setCurrentMyRole([...currentMyRole, id])
        }
    }

    useEffect(() => {
        if (student?.roles && student.roles.length > 0) {
            let myRoles = [];
            student.roles.map((item) => {
                myRoles.push(item.id)
            })
            setCurrentMyRole(myRoles)
        }

        if (student?.permission === 'admin') {
            setSuperAdmin(true)
        }
    }, [student])

    const saveRole = () => {
        if (student?.expert) {
            addUserRole(
                {
                    id: student?.id,
                    args: {
                        admin: superAdmin ? 'admin' : null,
                        roles: currentMyRole
                    }
                },
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                    },
                    onError: (err) => {
                        ApiHandleErrorMessage(err)
                    }
                }
            )
        }
    }
    return (
        <div className="flex flex-col gap-4">

            <Card title="نوع کاربر">
                <MemberTypeComponent member={student}/>
            </Card>
            <RenderIf condition={student?.expert}>

                <Card title="سطح دسترسی">
                    <div className="w-full">
                        <Can permission={PermList.MEMBER_PERMISSION_EDIT}>
                            <div className={`w-full rounded shadow-sm  flex flex-col gap-3 relative`}>


                                <div>
                                    {'اختصاص سطح دسترسی به کارشناس'}
                                    <>
                                        <div className={'flex gap-2 m-4'}>
                                            <Checkbox checked={superAdmin} onChange={(e) => {
                                                setSuperAdmin(!superAdmin)
                                            }}
                                                      disabled={!hasPermission(PermList.MEMBER_PERMISSION_EDIT)}
                                            />
                                            <div className={'font-bold'}>دسترسی کامل سامانه (ادمین)</div>
                                        </div>
                                        <RenderIf condition={superAdmin}>
                                            <span>فعال بودن این گزینه به منزله دسترسی کامل به تمامی امکانات سامانه به کارشناس می‌باشد.</span>
                                        </RenderIf>
                                        <RenderIf condition={!superAdmin}>
                                            <Divider/>
                                            <div className={`flex flex-col gap-1`}>
                                                <span className={`font-medium`}>نقش‌ها</span>
                                                {roles?.data?.data?.map((role) => {
                                                    return (
                                                        <div className={'flex gap-2'}>
                                                            <Checkbox checked={currentMyRole.includes(role?.id)}
                                                                      onChange={(e) => {
                                                                          handleChange(role?.id)
                                                                      }}
                                                                      disabled={!hasPermission(PermList.MEMBER_PERMISSION_EDIT)}
                                                            />
                                                            <div className={'font-medium'}>{role.name}</div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </RenderIf>
                                    </>
                                </div>
                                <Can permission={PermList.MEMBER_PERMISSION_EDIT}>
                                    <div
                                        onClick={() => saveRole()}
                                        className="flex items-end justify-end">
                                        <Button disabled={isPendingAddUserRole}
                                                loading={isPendingAddUserRole}
                                                type={`primary`}>ذخیره</Button>
                                    </div>
                                </Can>

                            </div>
                        </Can>
                    </div>
                </Card>
            </RenderIf>
        </div>
    );
}